import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col flex-wrap justify-center text-center"
}
const _hoisted_2 = { class: "mb-5 text-h-primary-500 text-2xl font-bold" }
const _hoisted_3 = {
  key: 1,
  class: "flex flex-col justify-center text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!

  return (_ctx.loader)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(`flex flex-col justify-center items-center ${_ctx.loaderSize} select-none`)
      }, [
        (_ctx.loaderType === 'progress')
          ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
              _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.label), 1),
              _createVNode(_component_ProgressBar, {
                mode: "indeterminate",
                class: "progressbar-style w-80",
                style: {"height":"0.5em"}
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.loaderType === 'spinner')
          ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
              _createVNode(_component_ProgressSpinner, {
                style: _normalizeStyle(_ctx.setSpinnerSize())
              }, null, 8, ["style"])
            ]))
          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}